import { render, staticRenderFns } from "./MonsterSelector.vue?vue&type=template&id=7e5fdb59"
import script from "./MonsterSelector.vue?vue&type=script&lang=js"
export * from "./MonsterSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e5fdb59')) {
      api.createRecord('7e5fdb59', component.options)
    } else {
      api.reload('7e5fdb59', component.options)
    }
    module.hot.accept("./MonsterSelector.vue?vue&type=template&id=7e5fdb59", function () {
      api.rerender('7e5fdb59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MonsterSelector.vue"
export default component.exports